export default "__VITE_ASSET__DykGZkCG__"